/* eslint-disable no-useless-catch */
import { PARTNER_TYPE, serialize } from '../utils';
import { FindOptions } from './common';
import { entityService } from './services';

const pathname = '/invitations';

export const InvitationApi = {
  find: async (options: FindOptions) => {
    let url = pathname;
    const query = serialize(options);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  filter: async (option: FindOptions) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (data: CreateInvitationBody) => {
    try {
      const response = await entityService.post(pathname, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createSyncProducts: async (data: CreateSyncProductsBody) => {
    const url = `${pathname}/sync-product`;
    try {
      const response = await entityService.post(url, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createSyncProductDiaries: async (data: CreateSyncProductDiariesBody) => {
    const url = `${pathname}/sync-product-diaries`;
    try {
      const response = await entityService.post(url, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateStatusSyncProducts: async (
    id: string,
    data: UpdateStatusSyncProductsBody
  ) => {
    const url = `${pathname}/${id}/status-sync-product`;
    try {
      const response = await entityService.patch(url, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateStatusSyncProductDiaries: async (
    id: string,
    data: UpdateStatusSyncProductsBody
  ) => {
    const url = `${pathname}/${id}/status-sync-product-diaries`;
    try {
      const response = await entityService.patch(url, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateStatus: async (id: string, status: number) => {
    try {
      const response = await entityService.patch(`${pathname}/${id}`, {
        status,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    try {
      const response = await entityService.delete(`${pathname}/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  cancelInvitation: async (id: string) => {
    try {
      const response = await entityService.delete(`${pathname}/cancel/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  findInvitationInfo: async (option: FindInvitationInfoOptions) => {
    let url = `${pathname}/find-invitation-info`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWaitingInvitation: async (option: FindOptions) => {
    let url = `${pathname}/find-waiting-approve-invitation`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface CreateInvitationBody {
  supplierProductIDs?: string[];
  isSelectAllProduct?: boolean;
  categoryID?: string;
  search?: string;
  entityPricePolicyID?: string | null;
  entityProposalPolicyID?: string | null;
  entityID: string;
  inviterID?: string;
  partnerGroupID?: string;
  introduction: string;
  shouldCreateDigitalMenu?: boolean;
  shouldSyncEntityCategory?: boolean;
  shouldCreateNewProduct?: boolean;
  partnerCode?: string;
  groupType?: number;
  partnerType?: PARTNER_TYPE;
}

export interface CreateSyncProductsBody {
  supplierProductIDs: string[];
  entityID: string;
  inviterID: string;
  shouldSyncEntityCategory?: boolean;
}

export interface CreateSyncProductDiariesBody {
  partnerEntityProductIDs: string[];
  supplierID: string;
  customerID: string;
  entityID?: string;
}

export interface UpdateStatusSyncProductsBody {
  supplierProductIDs: string[];
}

export interface FilterInvitationOptions {
  page?: number;
  take?: number;
  order?: any;
  reserved?: boolean;
  name?: string;
  entityID?: string;
  entityIDs?: string[];
  type?: number;
  status?: number;
}

export interface FindInvitationInfoOptions {
  groupType: number;
  invitationID: string;
  shouldReturnEntityPartnerType?: boolean;
  shouldReturnGroup?: boolean;
}
